import environment from '../../../common/environment';
import { ShopApi } from '../../../common/constants/shop-api';
import { getResponseData } from '../../../common/utils/api-utils';
import { OrderHistory } from '../../order-history/order-history.interface';
import { mapShopSampleOrderResponse } from '../../order-history/order-history.mapping';

export async function getInstructorSampleOrdersApiCall(token: string): Promise<OrderHistory[]> {
  const url = new URL(`${environment().magentoUrl}${ShopApi.ordersHistoryShopMagento}`);
  const response = await getResponseData(
    new Request(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
  );

  return mapShopSampleOrderResponse(response);
}
